const STORAGE_KEY = "wavemaker.progress-report.v1";

const DEFAULT_DATA = {
  playerName: "",
  timeSpentMs: 0,
};

const normalizeProgressReportData = (value) => {
  if (!value || typeof value !== "object") {
    return { ...DEFAULT_DATA };
  }
  const record = value;
  const normalized = { ...DEFAULT_DATA };

  if (typeof record.playerName === "string") {
    normalized.playerName = record.playerName;
  }
  if (Number.isFinite(record.timeSpentMs)) {
    normalized.timeSpentMs = Math.max(0, Math.floor(record.timeSpentMs));
  }

  return normalized;
};

export const loadProgressReportData = () => {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return { ...DEFAULT_DATA };
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return { ...DEFAULT_DATA };
    }
    return normalizeProgressReportData(JSON.parse(raw));
  } catch {
    return { ...DEFAULT_DATA };
  }
};

export const saveProgressReportData = (data) => {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
  }
};

export const setProgressReportName = (name) => {
  const trimmed = typeof name === "string" ? name.trim() : "";
  const data = loadProgressReportData();
  if (!trimmed || data.playerName) {
    return data;
  }
  const next = { ...data, playerName: trimmed };
  saveProgressReportData(next);
  return next;
};

export const addProgressReportFocusedTime = (milliseconds = 0) => {
  const increment = Number.isFinite(milliseconds) ? Math.floor(milliseconds) : 0;
  if (increment <= 0) {
    return loadProgressReportData();
  }
  const data = loadProgressReportData();
  const next = {
    ...data,
    timeSpentMs: Math.max(0, (data.timeSpentMs ?? 0) + increment),
  };
  saveProgressReportData(next);
  return next;
};
